<template>
  <div class="dialogs">
    <Dialog
      v-for="dialog in dialogs"
      :key="dialog.id"
      :dialog="dialog"
      :active-dialog="activeDialog"
      @setDialog="setDialog(dialog.id)"
    />
  </div>
</template>

<script>
import Dialog from './Dialog'

export default {
  components: { Dialog },
  props: {
    dialogs: Array,
    activeDialog: Number,
    setDialog: Function,
  },
}
</script>

<style lang="scss" scoped>
.dialogs {
  margin-top: 32px;
  flex: 1 0 auto;
}
</style>
